import { ChangeDetectorRef, Component, ElementRef, Inject, NgZone, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { SectorPageService } from '@app/_services/sectorPage.service';
import { SharedService } from '@app/_services/shared.service';
import { Subject, fromEvent } from 'rxjs';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { TranslateHelper } from './../../_helpers/translate-helper';
import { DirectionService } from './../../_services/direction.service';
import { isPlatformBrowser, NgIf, NgFor, NgClass } from '@angular/common';
import { HomepageService } from '@app/_services/homepage.service';
import { SiteService } from '@app/_services/site.service';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import * as _ from 'lodash';
import { MatIconModule } from '@angular/material/icon';
import { OwlPreventClickDirective } from '../../shared/directives/owl-prevent-click.directive';
import { CarouselModule } from 'ngx-owl-carousel-o';

@Component({
    selector: 'app-categories-underbar',
    templateUrl: './categories-header.component.html',
    styleUrls: ['./categories-header.scss'],
    providers: [TranslateHelper],
    standalone: true,
    imports: [NgIf, CarouselModule, OwlPreventClickDirective, NgFor, RouterLink, NgClass, MatIconModule, TranslateModule]
})
export class CategoriesHeader implements OnDestroy, OnInit {
    constructor(
        private sharedService: SharedService,
        private sectorService: SectorPageService,
        private homepageService: HomepageService,
        private router: Router,
        public sitesService: SiteService,
        public translateHelper: TranslateHelper,
        public direction: DirectionService,
        private translate: TranslateService,
        private elementRef: ElementRef,
        private zone: NgZone,
        private cdr: ChangeDetectorRef,
        @Inject(PLATFORM_ID) private platformId: any,
    ) { }

    destroy$: Subject<void> = new Subject<void>();
    modelChanged: Subject<any> = new Subject<any>();
    selectedcategory;
    selectedIndex = new UntypedFormControl(0);
    categories: any = [];
    sectorColors: any = {};
    sector;
    carouselOptions = {
        //items: 5,
        touchDrag: true,
        mouseDrag: true,
        dots: false,
        skip_validateItems: true,
        margin: 8,
        autoWidth: true,
        rtl: this.direction.isRTL()
    };

    currentLang = this.translate.currentLang;

    sectors = [];
    currentPage;
    sectorsOpen = false;
    hasProfessionals = false;
    private get element(): HTMLElement {
        return this.elementRef.nativeElement;
    }

    ngOnInit(): void {
        this.sectorService.categories$.pipe(takeUntil(this.destroy$)).subscribe((response) => {
            this.selectedIndex.setValue(0);
            this.categories = response;
            if (isPlatformBrowser(this.platformId)) {
                _.forEach(this.categories, (category, key) => {
                    let element = document.createElement('canvas');
                    let context = element.getContext("2d");
                    context.font = "15px Lato, sans-serif";
                    let fontSize = context.measureText(category?.name?.[this.translate.currentLang]).width;
                    this.categories[key].width = fontSize + 55;
                });
            }
        });

        this.sectorService.hasProfessionals$.pipe(takeUntil(this.destroy$)).subscribe((response) => {
            this.hasProfessionals = response;
        });

        this.sectorService.sectorColors$.pipe(takeUntil(this.destroy$)).subscribe((response) => {
            this.sectorColors = response;
        });

        this.sharedService.currentCategory$.pipe(takeUntil(this.destroy$)).subscribe((slug: any) => {
            if (slug) {
                this.selectedcategory = slug;
            } else {
                this.selectedcategory = null;
            }
        });

        this.sharedService.page$.pipe(takeUntil(this.destroy$)).subscribe((page) => {
            this.sector = page;
            this.cdr.detectChanges();
        }, (error => {
            //console.log(error);
        }));

        this.modelChanged.pipe(debounceTime(300),distinctUntilChanged()).subscribe((event) => {
            if (event?.index > 0) {
                let category = this.categories[event?.index - 1]?.seo?.slug
                if (this.sector && category) {
                    this.router.navigate(['/sector', this.sector, 'category', this.categories[event?.index - 1]?.seo?.slug]);
                    return;
                }
            }
        });

        this.sharedService.page$.subscribe(page => {
            this.currentPage = page;
        });

        if (isPlatformBrowser(this.platformId)) {
            this.zone.runOutsideAngular(() => {
                fromEvent<MouseEvent>(document, 'mousedown').pipe(
                    takeUntil(this.destroy$)
                ).subscribe((event) => {
                    let sectorsList = this.element.children.item(0).children.item(0);
                    if (!sectorsList.contains(event.target as HTMLElement)) {
                        this.zone.run(() => this.closeSectors());
                    }
                });
            });
        }

        this.sectors = [];
        this.homepageService.categories$.subscribe(data => {
            if (!data) {
                return;
            }
            this.sectors = data;
            if (isPlatformBrowser(this.platformId)) {
                _.forEach(this.sectors, (sector, key) => {
                    let element = document.createElement('canvas');
                    let context = element.getContext("2d");
                    context.font = "15px Lato, sans-serif";
                    let fontSize = context.measureText(sector?.name?.[this.translate.currentLang]).width;
                    this.sectors[key].width = fontSize + 55;
                });
            }
            // if (this.currentPage && this.currentPage != 'homepage') {
            //     let index = this.sectors.findIndex(item => item.seo?.slug == this.currentPage);
            // }
            // this.cd.detectChanges();
        });
    }

    getSectorName() {
        let sector = _.find(this.sectors, ['seo.slug', this.currentPage]);
        return sector?.name;
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    selectionChange(category) {
        if (this.sector && category) {
            this.selectedcategory = category.seo?.slug;
            return;
        }
    }

    selectSector(sector) {
        if (!sector?.seo?.slug) {
            return false;
        }
        this.sharedService.pageSubject$.next(sector?.seo?.slug);
    }

    sectorChange(event) {
        this.sharedService.currentCategorySubject$.next(null);
        this.selectSector(event);
        this.closeSectors();
    }

    openSectors(): void {
        this.sectorsOpen = true;
    }

    closeSectors(): void {
        this.sectorsOpen = false;
    }

    toggleSectors(): void {
        this.sectorsOpen = !this.sectorsOpen;
    }
}
